export default "__VITE_ASSET__Cdzq94Ws__"